import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, IsNumber, Model, ModelId } from '@core/shared/model';
import { CompanyDemoItem } from '../models';
let BeginDemoResponse = /*#__PURE__*/(() => {
  let BeginDemoResponse = class BeginDemoResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", CompanyDemoItem)], BeginDemoResponse.prototype, "demo", void 0);
  BeginDemoResponse = __decorate([ModelId("BeginDemoResponse") // auto-generated by generate-model-ids
  ], BeginDemoResponse);
  return BeginDemoResponse;
})();
export { BeginDemoResponse };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let BeginDemoRequest = /*#__PURE__*/(() => {
  let BeginDemoRequest = class BeginDemoRequest extends Model {
    static {
      this.Response = BeginDemoResponse;
    }
  };
  __decorate([Expose(), IsNumber(), __metadata("design:type", Number)], BeginDemoRequest.prototype, "companyId", void 0);
  BeginDemoRequest = __decorate([AppRequest('users', 'company-demos/begin', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("BeginDemoRequest") // auto-generated by generate-model-ids
  ], BeginDemoRequest);
  return BeginDemoRequest;
})();
export { BeginDemoRequest };